import { InputWithLabel, SelectOption, TextAreaWithLabel } from "newui/components/ui/InputWithLabel"
import { ClarificationImpact, ClarificationType } from "../../../types/clarification.type";
import { ClarificationTypeSelect } from "newui/components/ui/CommonSelects";

interface ClientCreationProps {
	// Kept for backward-compat with parent prop chain; the actual options
	// list now comes from the shared `useClarificationTypes` lookup so this
	// surface stays in sync with the panel-member clarification form.
	clarificationTypes?: ClarificationType[];
	errors: {
		clarification_type_id?: string;
		clarification_text?: string;
		owner?: string;
	},
	formData,
	impactOptions: SelectOption[],
	handleInputChange: (field: string, value: string | number) => void;
}

export const ClientCreation = ({ errors, formData, handleInputChange, impactOptions }: ClientCreationProps) => {
	return <>
		<ClarificationTypeSelect
			name="clarification_type_id"
			required
			value={formData.clarification_type_id || undefined}
			errorText={errors.clarification_type_id}
			onChange={(e: SelectOption) =>
				handleInputChange("clarification_type_id", Number(e.value))
			}
		/>

		<TextAreaWithLabel
			label="Clarification"
			name="clarification_text"
			placeholder="Enter your clarification request..."
			required
			value={formData.clarification_text}
			errorText={errors.clarification_text}
			onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
				handleInputChange("clarification_text", e.target.value)
			}
		/>

		<InputWithLabel label="Relates To" name="relates_to" type="text" placeholder="e.g. Returnable Schedule Question 1.5 or Quote Item 3" value={formData.relates_to} onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
			handleInputChange("relates_to", e.target.value)
		}
		/>

		<InputWithLabel
			guideLine="The person raising this clarification"
			label="Owner"
			name="owner"
			type="text"
			placeholder="Person responsible for this clarification"
			required
			value={formData.owner}
			errorText={errors.owner}
			onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
				handleInputChange("owner", e.target.value)
			}
		/>

		{/* <SelectWithLabel
			label="Impact"
			name="clarification_impact_id"
			placeholder="Select impact"
			options={impactOptions}
			value={impactOptions.find((type) => Number(type.value) === (formData.clarification_impact_id ?? ClarificationImpact.none))}
			onChange={(e: SelectOption) =>
				handleInputChange("clarification_impact_id", e?.value)
			}
			clearAble
		/> */}
	</>
}